var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "px-3"
  }, [_vm.application.identityCardList.length ? [_c('v-col', {
    staticClass: "pt-3 px-0 border-top",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text font-weight-bold"
  }, [_vm._v("Документ удостоверяющий личность")])]), _vm._l(_vm.application.identityCardList, function (item, i) {
    return _c('v-col', {
      key: i,
      staticClass: "pa-0 border-top",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-col', {
      staticClass: "pt-3 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Гражданство")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.citizenship.name))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Тип документа")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.identityCardDocType.name))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Серия")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.series))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Номер")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.number))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Дата выдачи")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.issueDate))])])], 1);
  })] : _vm._e(), _vm.application.educationList.length ? [_c('v-col', {
    staticClass: "pt-3 px-0 border-top",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text font-weight-bold"
  }, [_vm._v("Документ об образовании")])]), _vm._l(_vm.application.educationList, function (item, i) {
    return _c('v-col', {
      key: i + 50,
      staticClass: "pa-0 border-top",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-col', {
      staticClass: "pt-3 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Тип документа")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.educationDocType.name))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Серия")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.series))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Номер")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.number))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Дата выдачи")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.issueDate))])])], 1);
  })] : _vm._e(), _vm.application.trainingCertificateList.length ? [_c('v-col', {
    staticClass: "pt-3 px-0 border-top",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text font-weight-bold"
  }, [_vm._v("Справка об обучении")])]), _vm._l(_vm.application.trainingCertificateList, function (item, i) {
    return _c('v-col', {
      key: i + 100,
      staticClass: "pa-0 border-top",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-col', {
      staticClass: "pt-3 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Образовательная организация")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.organizationName))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Серия")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.series))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Номер")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.number))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Дата выдачи")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.issueDate))])])], 1);
  })] : _vm._e(), _vm.application.medicalCertificateList.length ? [_c('v-col', {
    staticClass: "pt-3 px-0 border-top",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text font-weight-bold"
  }, [_vm._v("Медицинская справка")])]), _vm._l(_vm.application.medicalCertificateList, function (item, i) {
    return _c('v-col', {
      key: i + 150,
      staticClass: "pa-0 border-top",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Серия")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.series))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Номер")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.number))])])], 1);
  })] : _vm._e(), _vm.application.militaryList.length ? [_c('v-col', {
    staticClass: "pt-3 px-0 border-top",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text font-weight-bold"
  }, [_vm._v("Документ о воинской обязанности")])]), _vm._l(_vm.application.militaryList, function (item, i) {
    return _c('v-col', {
      key: i + 200,
      staticClass: "pa-0 border-top",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Серия")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.series))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Номер")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.number))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Дата выдачи")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.issueDate))])])], 1);
  })] : _vm._e(), _vm.application.achievementList.length ? [_c('v-col', {
    staticClass: "pt-3 px-0 border-top",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text font-weight-bold"
  }, [_vm._v("Достижения")])]), _vm._l(_vm.application.achievementList, function (item, i) {
    return _c('v-col', {
      key: i + 250,
      staticClass: "pa-0 border-top",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-col', {
      staticClass: "pt-3 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Наименование достижения")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.name))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Серия")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.series))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Номер")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.number))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Дата выдачи")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.issueDate))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Кем выдано")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.issueBy))])])], 1);
  })] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }